/**
 * The external dependencies.
 */
import styled from 'styled-components';

export default styled.button`
	position: relative;
	font-size: 10px;
	color: #439DD5;
	text-align: center;
	text-decoration: none;
	background: transparent;
	min-width: 153px;
	padding: 8px 0 9px;
	border: 2px solid #439DD5;
	border-radius: 3px;
	transition: .3s;
	${({shadow}) => shadow ? 'box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);' : ''}

	&:hover {
		background: #439DD5;
		color: #fff;

		span {
			border-color: #fff;
		}
	}
`;


// WEBPACK FOOTER //
// ./src/components/general/button.js